module.exports = __webpack_public_path__ + "static/media/Maf_PrivilegiosMaculinos.1a912907.jpg";